import { createSvgEl } from '@learnforge/demo-render';

/**
 * A small drawn coin: a <g class="fin-coin"> with an outer disc + inner ring,
 * sized `size` px. Font-portable — drawn in SVG rather than relying on a
 * Unicode glyph.
 */
export function createCoinIcon(size = 14): SVGGElement {
  const r = size / 2;
  const innerR = r * 0.6;

  const g = createSvgEl('g', { class: 'fin-coin' });

  const outer = createSvgEl('circle', { cx: 0, cy: 0, r });
  const inner = createSvgEl('circle', { cx: 0, cy: 0, r: innerR });

  g.appendChild(outer);
  g.appendChild(inner);

  return g;
}
